import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { SELLER_TYPE } from 'domains/seller/constants/seller-constants'

/**
 * To give nice look in seller type by given seller type of the seller
 * @param {string} seller_type seller type. available value
 * - `normal`
 * - `exclusive`
 * - `featured`
 * - `designer`
 * - `scraper
 */
const SellerBadge = ({ seller_type, ...props }) => {

  const colorMap = {
    [SELLER_TYPE.NORMAL]    : 'primary',
    [SELLER_TYPE.FEATURED]  : 'info',
    [SELLER_TYPE.DESIGNER]  : 'warning',
    [SELLER_TYPE.EXCLUSIVE] : 'success',
    [SELLER_TYPE.SCRAPER]   : 'secondary'
  }

  const color = colorMap[seller_type] || 'default'

  return (
    <StatusBadge
      { ...props }
      color={ color }
      label={ seller_type }
    />
  )
}

SellerBadge.propTypes = {
  seller_type: PropTypes.string
}

export default SellerBadge